import React, { useState, useEffect } from "react";

const WhatsappBadge = () => {
  const [isVisible, setIsVisible] = useState(false); // Controls delay
  const [isOpen, setIsOpen] = useState(false);       // Controls chat box
  const [message, setMessage] = useState("");        // Controls input text

  // 1. Trigger the badge to appear after a delay (e.g., 3 seconds)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 7000); 

    return () => clearTimeout(timer);
  }, []);

  // 2. Handle sending the message
  const handleSendMessage = () => {
    if (!message.trim()) return; // Don't send empty messages

    const phoneNumber = "447897035008";
    // Encode the text to make it URL safe
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
    setMessage(""); // Clear input after sending (optional)
    setIsOpen(false); // Close box after sending (optional)
  };


  return (
    <div style={styles.container}>
      {/* The Chat Box Widget */}
      {isOpen && (
        <div style={styles.chatBox}>
          <div style={styles.header}>
            <span>Chat with us</span>
            <button onClick={() => setIsOpen(false)} style={styles.closeBtn}>
              &times;
            </button>
          </div>
          <div style={styles.body}>
            <p style={styles.helperText}>
              Hi there! Type a message and we'll reply on WhatsApp.
            </p>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="How can we help you?"
              style={styles.textarea}
              rows={3}
            />
            <button onClick={handleSendMessage} style={styles.sendBtn}>
              Start Chat &rarr;
            </button>
          </div>
        </div>
      )}

      {/* The Floating Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="wp-badge"
        style={styles.floatingButton}
      >
        <img
          src="/wphome-icon.png"
          alt="WhatsApp"
          style={{ width: "55px", display: "block" }}
        />
        {/* Helper Badge: Shows a notification dot if closed */}
        {!isOpen && <span className="wp-dot" style={styles.dot}></span>}
      </button>
    </div>
  );
};

// --- Styles (CSS-in-JS for easy implementation) ---
const styles = {
  container: {
    position: "fixed",
    bottom: "30px",
    right: "20px",
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    fontFamily: "sans-serif",
  },
  chatBox: {
    width: "300px",
    backgroundColor: "white",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    marginBottom: "15px",
    overflow: "hidden",
    animation: "fadeIn 0.3s ease-in-out",
  },
  header: {
    backgroundColor: "#075e54", // WhatsApp dark green
    color: "white",
    padding: "12px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    color: "white",
    fontSize: "20px",
    cursor: "pointer",
  },
  body: {
    padding: "15px",
  },
  helperText: {
    fontSize: "14px",
    color: "#555",
    margin: "0 0 10px 0",
    lineHeight: "1.4",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    marginBottom: "10px",
    resize: "none",
    fontSize: "14px",
    boxSizing: "border-box", // Prevents padding from breaking width
  },
  sendBtn: {
    width: "100%",
    backgroundColor: "#25D366", // WhatsApp bright green
    color: "white",
    border: "none",
    padding: "10px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
  },
  floatingButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    position: "relative",
    padding: 0,
    transition: "transform 0.2s",
  },
  dot: {
    position: "absolute",
    top: "3px",
    right: "3px",
    height: "12px",
    width: "12px",
    backgroundColor: "red",
    borderRadius: "50%",
    border: "2px solid red",
  }
};

export default WhatsappBadge;